module.exports = "/packs/001-9af9aaa1b5d787eef38c3a63c7cc7d49.jpg";